<template>
	<v-form ref="form" v-model="formIsValid" lazy-validation>
		<modal
			:exibir="exibir"
			:titulo="tituloModal"
			nome-botao-confirmar="Salvar"
			:is-confirmar-visivel="isConfirmarVisivel"
			:tamanho="modalOptions"
			:custom-actions="false"
			:acao-cancelar="fecharModal"
			:acao-confirmar="confirmarBloquear"
			@close="fecharModal"
		>
			<template #body>
				<div class="my-1 pt-1" :class="{ ajustar_modal_aba_historico: !$vuetify.breakpoint.mobile }">
					<painel-com-tabs-sem-rotas :tabs="getTabs" @tab-atual="botaoBloquearNaoDeveAparecerNaAba">
						<template #bloquear>
							<bloqueio-item
								:item-para-bloquear="itemSelecionado"
								:itens-para-bloquear="itensBloqueio"
							></bloqueio-item>
						</template>
						<template #historico>
							<div class="mt-2">
								<historico-bloqueio :item-selecionado="itemSelecionado"></historico-bloqueio>
							</div>
						</template>
						<template #acoes-tabs>
							<botao-gerar-pdf-historico
								:tipo-historico="tipoHistorico.HISTORICO_BLOQUEIO"
								:id-entidade="itemSelecionado.id"
								v-if="!isConfirmarVisivel"
							></botao-gerar-pdf-historico>
						</template>
					</painel-com-tabs-sem-rotas>
				</div>
			</template>
		</modal>
	</v-form>
</template>

<script>
import { TabSemRotaUtils } from '@/core/utils'
import BloqueioItem from '@/views/pages/ata/acessar/gestao-da-ata/itens/listagem/bloqueio/bloquear/BloquearItem.vue'
import HistoricoBloqueio from '@/views/pages/ata/acessar/gestao-da-ata/itens/listagem/bloqueio/historico/HistoricoBloqueio'
import { actionTypes, getterTypes, mutationTypes } from '@/core/constants'
import { mapState } from 'vuex'
import validacaoAta from '@/views/mixins/validacaoAta'
import tipoHistorico from '@/core/constants/tipo-historico'
import BotaoGerarPdfHistorico from '@/views/components/botoes/gerar-pdf-historico/BotaoGerarPdfHistorico.vue'

export default {
	name: 'modal-bloquear',
	components: { BotaoGerarPdfHistorico, BloqueioItem, HistoricoBloqueio },
	mixins: [validacaoAta],
	props: {
		exibir: {
			type: Boolean,
		},
		itemSelecionado: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			tabsSemHistorico: [new TabSemRotaUtils(1, 'Bloquear', 'bloquear', () => this.temPermissaoEdicao)],
			tabsBloquear: [
				new TabSemRotaUtils(1, 'Bloquear', 'bloquear', () => this.temPermissaoEdicao),
				new TabSemRotaUtils(2, 'Histórico', 'historico', this.existeHistorico),
			],
			tabsDesbloquear: [
				new TabSemRotaUtils(1, 'Desbloquear', 'bloquear', () => this.temPermissaoEdicao),
				new TabSemRotaUtils(2, 'Histórico', 'historico', this.existeHistorico),
			],
			modalOptions: {
				largura: '900',
				altura: '500',
			},
			isConfirmarVisivel: true,
			formIsValid: true,
		}
	},
	computed: {
		tipoHistorico() {
			return tipoHistorico
		},
		...mapState({
			itemBloqueio: (state) => state.itemAta.bloqueio.bloquear,
			itensBloqueio: (state) => state.itemAta.itensAtaSelecionados,
		}),
		getTabs() {
			if (this.itemSelecionado) {
				if (!this.itemSelecionado.isBloqueado) return this.tabsBloquear
				return this.tabsDesbloquear
			}
			return this.tabsSemHistorico
		},
		tituloModal() {
			if (this.itemSelecionado) {
				if (!this.itemSelecionado.isBloqueado) return 'Bloquear Item'
				return 'Desbloquear Item'
			}
			return 'Bloquear Itens'
		},
	},
	beforeDestroy() {
		this.$store.commit(mutationTypes.ITEM_ATA.RESET_ITENS_ATA_SELECIONADOS)
	},
	methods: {
		botaoBloquearNaoDeveAparecerNaAba(tabValue) {
			const naoEhHistorico = tabValue !== 1

			if (this.temPermissaoEdicao) {
				this.isConfirmarVisivel = naoEhHistorico
			} else {
				this.isConfirmarVisivel = !naoEhHistorico
			}
		},
		fecharModal() {
			this.$emit('fechar-modal')
		},

		async confirmarBloquear() {
			if (this.$refs.form.validate()) {
				this.adicionarIdsItensBloqueio()

				if (this.itemBloqueio.isBloquear === true) {
					await this.$store.dispatch(actionTypes.ITEM_ATA.BLOQUEIO.BLOQUEAR.BLOQUEAR_ITENS)
				} else if (this.itemBloqueio.ids.length === 1) {
					this.itemBloqueio.idItemAta = this.itemSelecionado.id
					await this.$store.dispatch(actionTypes.ITEM_ATA.BLOQUEIO.BLOQUEAR.DESBLOQUEAR_ITENS)
				}

				await this.fecharModalAposConfirmacao()
			}
		},

		adicionarIdsItensBloqueio() {
			if (this.itemSelecionado) {
				this.itemBloqueio.ids.push(this.itemSelecionado.id)
			} else {
				if (this.itensBloqueio.length > 0) {
					this.itensBloqueio.forEach((item) => {
						if (!item.isBloqueado) {
							this.itemBloqueio.ids.push(item.id)
						}
					})

					this.itemBloqueio.isBloquear = true
				}
			}
		},
		async fecharModalAposConfirmacao() {
			this.mostrarNotificacaoSucessoDefault()
			this.$emit('carregar-listagem-item')
			this.$emit('fechar-modal')
		},
		existeHistorico() {
			return this.$store.getters[getterTypes.ITEM_ATA.EXISTE_HISTORICO_BLOQUEIO]
		},
	},
}
</script>

<style lang="stylus" scoped>

.ajustar_modal_aba_historico {
	height: 67vh;
}
</style>
